import TabsData from "./tabs";
import WordBook from "./wordbook";

// 初始化 APP mobx基本数据，包括 token、用户信息、用户权限数据
export const mobxTabsData = (() => new TabsData())();
export const mobxWordBook = (() => new WordBook())();
